import React from 'react';
import { motion } from 'framer-motion';
import './TourPackages.css';

const tourPackages = [
    { destination: "Madurai", image: "../images/Tour/Madurai.webp", price: "₹2000", duration: "1 Day" },
    { destination: "Kodaikanal", image: "../images/Tour/kodaikanal.webp", price: "₹6999", duration: "3 Days / 2 Nights" },
    { destination: "Munnar", image: "../images/Tour/Munnar.webp", price: "₹7999", duration: "3 Days / 2 Nights" },
    { destination: "Kanyakumari", image: "../images/Tour/Kanyakumari.webp", price: "₹4999", duration: "2 Days / 1 Night" },
    { destination: "Rameswaram", image: "../images/Tour/Rameshwaram.webp", price: "₹3999", duration: "2 Days / 1 Night" },
    { destination: "Velankanni", image: "../images/Tour/Velankanni.webp", price: "₹5999", duration: "2 Days / 1 Night" },
    { destination: "Coimbatore", image: "../images/Tour/Coimbatore.webp", price: "₹5999", duration: "2 Days / 1 Night" },
    { destination: "Trichy", image: "../images/Tour/Tiruchirappalli.webp", price: "₹5999", duration: "2 Days / 1 Night" },
    { destination: "Thanjavur", image: "../images/Tour/Thanjavur.webp", price: "₹5999", duration: "2 Days / 1 Night" },
    { destination: "Trivandrum", image: "../images/Tour/Trivandrum.webp", price: "₹5999", duration: "2 Days / 1 Night" },
    { destination: "Alappuzha", image: "../images/Tour/Alappuzha.webp", price: "₹5999", duration: "2 Days / 1 Night" },
    { destination: "Thekkady", image: "../images/Tour/Thekkady.webp", price: "₹5999", duration: "2 Days / 1 Night" },

];

const TourPackages = () => {
    return (
        <div className="container">
            <h3 className="tour-subtitle">Welcome to Our</h3>
            <h2 className="tour-title">Tour Packages</h2>
            <div className="tour-grid">
                {tourPackages.map((tour, index) => (
                    <motion.div
                        key={index}
                        className="tour-card"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        transition={{ duration: 0.3 }}
                    >
                        <img src={tour.image} alt={tour.destination} className="tour-image" />
                        <div className="tour-content">
                            <h4 className="tour-destination">{tour.destination}</h4>
                            {/* <p className="tour-duration">{tour.duration}</p>
                            <p className="tour-price">{tour.price}</p> */}
                            {/* <button className="book-now-btn">Book Now</button> */}
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default TourPackages;
